module.exports = __webpack_public_path__ + "img/charging-session-infograph-desktop-fr.ed07ea51.webp";